import { Avatar, UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './BuilderCall.css';

interface IBuilderCallProps {
  name: string;
  logo: string;
  url: string;
  phoneButton: React.ReactElement;
}

export const BuilderCall: React.FC<IBuilderCallProps> = ({ name, logo, url, phoneButton }) => {
  return (
    <div>
      <UIHeading4>Позвоните подрядчику</UIHeading4>
      <div className={styles['content']}>
        <div className={styles['info']}>
          <Avatar size={40} type="builder" src={logo} href={url} target="_blank" />
          <div className={styles['company']}>
            <UIText2>
              <a className={styles['link']} href={url} target="_blank" rel="noopener noreferrer">
                {name}
              </a>
            </UIText2>
            <UIText2 color="text-secondary-default">Строительная компания</UIText2>
          </div>
        </div>
        {phoneButton}
      </div>
    </div>
  );
};
